import React, { FC, useEffect, useState } from 'react';
import withLocalization from '../hoc/withLocalization';
import ParseHtml from '../common/ParseHtml';
import LeadSubmitButton from './LeadSubmitButton';
import ConsentAgreementModal from '../MarketingConsentAgreement/ConsentAgreementModal';
import { maskName, maskEmail, maskPhoneNumber } from './LeadInfoUtils';
import { capitalizeFirstLetter } from '../../util/CommonLogic';
//import { useDispatch, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
//import { RootState } from '../../redux/rootReducer';
import { setMailingAddressInfo } from '../../features/OfferPaymentContainer/OfferPaymentSlice';
import { States_US } from '../../util/States';
import './LeadInfoDetails.scss';
import { useCountryPhoneCodes } from '../../util/useCountryPhoneCodes';
import { useCountryCodeByName } from '../../util/useCountryCodeByName';
import isAsia from '../../util/isAsia';

interface SearchPanelProps {
  localize?: any;
  localizeImages?: any;
  history: any;
  leadDetails?: any;
}
const EditLeadInfoDetails: FC<SearchPanelProps> = (props: SearchPanelProps) => {
  const { localize, leadDetails } = props;
  const countries = useCountryPhoneCodes();
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const defaultCountrylCode: any = leadDetails?.phone ? '' : leadDetails?.countryCode;
  const defaultDialCode: any = useCountryCodeByName(defaultCountrylCode);
  const [dialCode, setDialCode] = useState(defaultDialCode || '');
  const [emailErr, setEmailErr] = useState('');
  const [phoneErr, setPhoneErr] = useState('');
  const [isValidForm, setIsValidForm] = useState(false);
  const [isCheckedContactMe, setIsCheckedContactMe] = useState(false);
  const [consentModalOpen, setConsentModalOpen] = useState(false);
  const capFirstName = capitalizeFirstLetter(leadDetails?.firstName);
  const capLastName = capitalizeFirstLetter(leadDetails?.lastName);
  const fullName = `${capFirstName} ${capLastName}`;
  //const mailingErr = useSelector((state: RootState) => state.pinOptFlowDetails.);
  const stateData = States_US.find((item) => item.code === leadDetails?.stateProvince);
  const desc = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-opt-in-description')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-opt-in-description');
  const dispatch = useDispatch();

  const checkEmpty = (val: any) => {
    const isEmpty = val?.trim() === '' ? true : false;
    return isEmpty;
  };

  const isValidEmail = (val: any) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return !emailPattern.test(val);
  };
  const isInvalidPhone = (val: any) => {
    //nst phoneValidator: RegExp = new RegExp(/^[1-9][0-9]{9}$/);
    const phoneValidator: RegExp = new RegExp(/^\d{3,}$/);
    return !phoneValidator.test(val);
  };

  const chkValidMail = (val: any) => {
    if (checkEmpty(val)) {
      return `preview-sales-engine.static-content.copy.contact-information-page.email-error#required`;
    } else if (isValidEmail(val)) {
      return `preview-sales-engine.static-content.copy.contact-information-page.email-error#invalid`;
    } else {
      return '';
    }
  };
  const chkValidPhone = (val: any) => {
    if (checkEmpty(val)) {
      return `preview-sales-engine.static-content.copy.Labels.error-message.pbeo.intl-phone-error#required`;
    } else if (isInvalidPhone(val)) {
      return `preview-sales-engine.static-content.copy.Labels.error-message.pbeo.intl-phone-error#invalid`;
    } else {
      return '';
    }
  };

  const handleEditMailChange = (evt: any) => {
    const emailVal = evt.target.value;
    setEmail(emailVal);
    const mailErrMsg = chkValidMail(emailVal);
    setEmailErr(mailErrMsg);
    if (mailErrMsg) {
      setIsValidForm(false);
    } else {
      if (!phoneErr && (phone || leadDetails?.phone)) {
        setIsValidForm(true);
      } else {
        setIsValidForm(false);
      }
    }
  };
  const handleEditPhoneChange = (evt: any) => {
    const phoneVal = evt.target.value;
    setPhone(phoneVal);
    const phoneErrMsg = chkValidPhone(phoneVal);
    setPhoneErr(phoneErrMsg);
    if (phoneErrMsg) {
      setIsValidForm(false);
    } else {
      if (!emailErr && (email || leadDetails?.email)) {
        setIsValidForm(true);
      } else {
        setIsValidForm(false);
      }
    }
  };
  const handleCheckboxClick = () => {
    setIsCheckedContactMe(!isCheckedContactMe);
  };
  const handleDialCodeChange = (val: any) => {
    setDialCode(val);
  };
  const closeModal = () => {
    setConsentModalOpen(false);
  };

  /*useEffect(() => {
    setIsValidForm(false);
    if (!emailErr && (email || leadDetails?.email) && !phoneErr && (phone || leadDetails?.phone)) {
      setIsValidForm(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mailingErr]);*/

  useEffect(() => {
    //add prospect details to state object. Needs to be set even if all address data is present and we do not show the address details component
    const payloadData = {
      address: leadDetails?.addressLine1 || '',
      city: leadDetails?.city || '',
      zipCode: leadDetails?.postalCode || '',
      state: stateData?.name || '',
      stateCode: stateData?.code || '',
    };
    dispatch(setMailingAddressInfo(payloadData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {consentModalOpen && <ConsentAgreementModal closeModal={closeModal} />}
      <div className="leadInfoHeadContainer">
        <span className="leadInfo-head-wrapper">
          {localize('preview-sales-engine.static-content.copy.pbeo.verify-page-header')}
        </span>

        <span className="leadInfo-head-desc">
          {localize('preview-sales-engine.static-content.copy.pbeo.verify-page-description')}
        </span>
      </div>
      <div className="leadInfo-form">
        <div className="leadInfo-RowContainer">
          <span className="leadInfo-form-lbl">
            {localize('preview-sales-engine.static-content.copy.associate-search-page.name-label')}
          </span>
          <span className="leadInfo-form-data">{maskName(fullName)}</span>
        </div>
        <div className="leadInfo-RowContainer">
          <span className="leadInfo-form-lbl">
            {localize('preview-sales-engine.static-content.copy.associate-search-page.email-label')}
          </span>
          {leadDetails?.email ? (
            <span className="leadInfo-form-data">{maskEmail(leadDetails?.email)}</span>
          ) : (
            <input
              type="email"
              value={email}
              id="editEmail"
              onChange={handleEditMailChange}
              onBlur={handleEditMailChange}
              className="leadInfo-input-edit"
              maxLength={35}
              autoComplete={'email'}
              aria-label="leadMail"
            />
          )}
          {emailErr && !leadDetails?.email && <span className="res-inline-err">{localize(emailErr)}</span>}
        </div>
        <div className="leadInfo-RowContainer">
          <span className="leadInfo-form-lbl">
            {localize('preview-sales-engine.static-content.copy.associate-search-page.phone-label')}
          </span>
          {leadDetails?.phone ? (
            <span className="leadInfo-form-data">{maskPhoneNumber(leadDetails?.phone)}</span>
          ) : (
            <div className="phone-field">
              <div className="code-select-wrapper">
                <select
                  className="code-select"
                  aria-label="countryCode"
                  value={dialCode}
                  onChange={(e) => handleDialCodeChange(e.target.value)}
                >
                  {countries?.map((country: any) => (
                    <option key={country.code} value={country.code}>
                      {`+${country.code}`}
                    </option>
                  ))}
                </select>
              </div>
              <input
                className="phone-input"
                type="tel"
                value={phone}
                maxLength={15}
                autoComplete={'tel-national'}
                onChange={handleEditPhoneChange}
                onBlur={handleEditPhoneChange}
                id="editPhone"
                aria-label="leadPhone"
              />
            </div>
          )}
          {phoneErr && !leadDetails?.phone && <span className="res-inline-err">{localize(phoneErr)}</span>}
        </div>

        <div className="leadInfo-consent-container">
          <div className="custom-checkbox-wrapper" id="checkboxWrapper">
            <input
              type="checkbox"
              aria-label="leadCheck"
              className="custom-checkbox"
              id="customCheck"
              onChange={handleCheckboxClick}
            />
          </div>
          <span className="leadInfo-consent-Desc">
            <ParseHtml htmlInput={desc}></ParseHtml>
          </span>
        </div>

        <LeadSubmitButton
          isValidForm={isValidForm}
          isEdit={true}
          email={email}
          phone={phone}
          ischecked={isCheckedContactMe}
          leadDetails={leadDetails}
          dialCode={dialCode}
        />
      </div>
    </>
  );
};
export default withLocalization(EditLeadInfoDetails);
